import React from 'react';
import { Brain, Target, Users, Shield } from 'lucide-react';

const MetricsSection = () => {
  const metrics = [
    { 
      icon: <Brain size={48} />, 
      label: "Modelo de Aprendizaje Evolutivo", 
      description: "Nuestra IA se perfecciona con cada dato que procesas. Cuanto más la utilizas, más aprende de los patrones específicos de tu granja, aumentando continuamente la fiabilidad de sus predicciones para optimizar tus resultados." 
    },
    { 
      icon: <Target size={48} />, 
      label: "Optimización Dirigida de Objetivos", 
      description: "Potencia tus resultados productivos. La herramienta te guía con análisis predictivos para seleccionar las combinaciones más eficaces, ayudándote a maximizar el rendimiento de cada cubrición y a convertir tus metas en logros tangibles." 
    },
    { 
      icon: <Users size={48} />, 
      label: "Plataforma de Colaboración Centralizada", 
      description: "Todo tu equipo trabaja sobre los mismos datos en tiempo real. Se eliminan las notas en papel y las dudas, permitiendo una coordinación perfecta y una toma de decisiones más rápida y unificada, estés donde estés." 
    },
    { 
      icon: <Shield size={48} />, 
      label: "Privacidad y Propiedad de tus Datos", 
      description: "Los datos de tu explotación son tuyos y de nadie más. Garantizamos su total confidencialidad y nunca serán compartidos con terceros. Tu información se utiliza únicamente para mejorar tus propios resultados." 
    }
  ];

  return (
    <section className="metrics-section">
      <div className="metrics-container">
        {metrics.map((metric, index) => (
          <div key={index} className="metric-item">
            <div className="metric-icon">{metric.icon}</div>
            <div className="metric-label">{metric.label}</div>
            <div className="metric-description">{metric.description}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MetricsSection;